"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var Text_1 = require("../Text");
var Legend_1 = require("../Legend");
var styles_1 = __importDefault(require("./styles"));
exports.Toggle = react_1.default.memo(react_1.default.forwardRef(function (_a, ref) {
    var value = _a.value, _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b, disabled = _a.disabled, _c = _a.useLabel, useLabel = _c === void 0 ? false : _c, _d = _a.labelPlacement, labelPlacement = _d === void 0 ? 'end' : _d, legend = _a.legend, defaultValue = _a.defaultValue, _e = _a.options, options = _e === void 0 ? {
        on: { label: 'Yes', value: true },
        off: { label: 'No', value: false },
    } : _e, rest = __rest(_a, ["value", "onChange", "disabled", "useLabel", "labelPlacement", "legend", "defaultValue", "options"]);
    var classes = (0, styles_1.default)({ disabled: disabled });
    var defaultRef = react_1.default.useRef();
    var resolvedRef = ref || defaultRef;
    var checked = value === options.on.value;
    var Switch = (0, react_1.useMemo)(function () {
        var changeHandler = function (event) {
            onChange(event, { checked: event.target.checked });
        };
        return ((0, jsx_runtime_1.jsx)(core_1.Switch, __assign({ checked: checked, inputProps: { 'aria-label': 'switch' }, inputRef: resolvedRef, focusVisibleClassName: classes.focusVisible, disableRipple: true, disabled: disabled, onChange: changeHandler, color: "primary", classes: {
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            } }, rest)));
    }, [
        checked,
        classes.checked,
        classes.focusVisible,
        classes.root,
        classes.switchBase,
        classes.thumb,
        classes.track,
        disabled,
        onChange,
        resolvedRef,
        rest,
    ]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [legend && (0, jsx_runtime_1.jsx)(Legend_1.Legend, { children: legend }), useLabel ? ((0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ size: "medium", lineHeight: 1.55 }, { children: (0, jsx_runtime_1.jsx)(core_1.FormControlLabel, { className: classes.label, control: 
                    // block is necessary to provide padding when paired with a label
                    (0, jsx_runtime_1.jsx)(core_1.Box, __assign({ display: "inline-block", paddingX: "12px" }, { children: Switch })), label: checked ? options.on.label : options.off.label, labelPlacement: labelPlacement }) }))) : (Switch)] }));
}));
